// src/pages/Volunteer.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import VolunteerForm from '../components/Forms/VolunteerForm';

const Volunteer: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Volunteer - Impact Generation Africa</title>
        <meta 
          name="description" 
          content="Join our volunteer team and make a difference in African communities through sustainable development projects." 
        />
      </Helmet>

      {/* Hero Section */}
      <section 
        className="py-5 bg-success text-white"
        style={{ marginTop: '76px' }}
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-5 fw-bold mb-4">Join Our Volunteer Team</h1>
              <p className="lead mb-0">
                Make a tangible impact in African communities through our sustainable 
                development initiatives. Your skills and passion can drive real change.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Volunteer Opportunities */}
      <section className="py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="fw-bold text-success mb-4">Volunteer Opportunities</h2>
            </div>
          </div>
          
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="text-success mb-3" style={{ fontSize: '3rem' }}>🌾</div>
                  <h5 className="card-title">Food Security Programs</h5>
                  <p className="card-text text-muted">
                    Help communities establish sustainable farming practices and food systems.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="text-success mb-3" style={{ fontSize: '3rem' }}>🌍</div>
                  <h5 className="card-title">Climate Action</h5>
                  <p className="card-text text-muted">
                    Participate in tree planting, environmental conservation, and climate education.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="text-success mb-3" style={{ fontSize: '3rem' }}>👨‍🎓</div>
                  <h5 className="card-title">Youth Empowerment</h5>
                  <p className="card-text text-muted">
                    Mentor and train youth in sustainable development skills and leadership.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Volunteer Form */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="fw-bold text-success mb-3">Apply to Volunteer</h2>
              <p className="text-muted">Fill out the form below and we'll get back to you soon.</p>
            </div>
          </div>
          
          <VolunteerForm />
        </div>
      </section>
    </>
  );
};

export default Volunteer;